@if (hasProductImage) {
  <img (error)="onFailToLoad($event)"
    [src]="fullUrl"
    alt="Product thumbnail"
    class="image"/>
}

@if (!hasProductImage) {
  <mat-icon
    class="missing">
    photo_camera
  </mat-icon>
}
